import React, { useRef } from 'react';
import { Link as ScrollLink } from 'react-scroll/modules';
import dynamic from 'next/dynamic';
import classnames from 'classnames/bind';
import styles from './tutorial.module.scss';
const ReactPlayer = dynamic(() => import('react-player') as any, { ssr: false }) as any;

const cx = classnames.bind(styles);

interface OrderListItemProps {
  href: string;
  title: string;
  url: string;
}

const OrderListItem = (orderListItemProps: OrderListItemProps) => {
  const { href, title, url } = orderListItemProps;
  const player = useRef<any>(null);

  return (
    <li className={cx('listItem')}>
      <ScrollLink to={href} smooth={true} className={cx('link')} role="button">
        <div className={cx('videoWrap')}>
          <ReactPlayer
            ref={player}
            url={`/video/acc/tutorial/${url}`}
            playing={true}
            muted={true}
            loop={true}
            width={'100%'}
            height={'100%'}
          />
        </div>
        <em className={cx('listTitle')}>{title}</em>
      </ScrollLink>
    </li>
  );
};

const OrderList = () => {
  return (
    <div className={cx('orderArea')}>
      <em className={cx('title')}>
        <span className={cx('textEmphasis')}>역검</span> 수련하기 순서
      </em>
      <ul className={cx('orderList')}>
        <OrderListItem href={'tutorial1'} title="환경체크" url="videoOrder1.mp4" />
        <OrderListItem href={'tutorial2'} title="성향파악" url="videoOrder2.mp4" />
        <OrderListItem href={'tutorial3'} title="전략게임" url="videoOrder3.mp4" />
        <OrderListItem href={'tutorial4'} title="영상면접" url="videoOrder4.mp4" />
      </ul>
    </div>
  );
};

export default OrderList;
